// extracted by mini-css-extract-plugin
module.exports = {"frame":"customizerModal_frame__3FrJL","modal":"customizerModal_modal__3X-QZ","close":"customizerModal_close__u1Hdq","modal-content":"customizerModal_modal-content__RTQAh"};